import {
  useFetchUser,
  useAnalyticsIdentifyUser,
  useAnalyticsRegisterUser,
} from './hooks';

export const useGetUser = () => {
  const { user, isLoading } = useFetchUser();

  useAnalyticsIdentifyUser(user);
  useAnalyticsRegisterUser();

  return { isLoading };
};
